import o from "./highrise615.mjs";
/* empty css             */
import t from "./highrise177.mjs";
const e = /* @__PURE__ */ t(o, [["__scopeId", "data-v-326e8c1a"]]);
export {
  e as default
};
